export const NAME = 'SingleHistoricalFlightStatus';
